import * as React from 'react'
  /* @jsx mdx */
import { mdx } from '@mdx-js/react';
/* @jsxRuntime classic */
/* @jsx mdx */
import DefaultLayout from "/home/runner/work/document-services/document-services/node_modules/@adobe/gatsby-theme-aio/src/components/MDXFilter/index.js";
export const _frontmatter = {};
const makeShortcode = name => function MDXDefaultShortcode(props) {
  console.warn("Component " + name + " was not imported, exported, or provided by MDXProvider as global scope");
  return <div {...props} />;
};
const TextBlock = makeShortcode("TextBlock");
const layoutProps = {
  _frontmatter
};
const MDXLayout = DefaultLayout;
export default function MDXContent({
  components,
  ...props
}) {
  return <MDXLayout {...layoutProps} {...props} components={components} mdxType="MDXLayout">


    <TextBlock slots="heading, text" width="100%" theme="lightest" alignment="yes" className="py-0 text-align-left div-p-0 left-content accessibility-text-blade text-blade-header heading-accessibility" mdxType="TextBlock" />
    <h2 {...{
      "id": "interested-in-joining-the-beta-program-for-the-adobe-importexport-form-data-apis"
    }}>{`Interested in joining the Beta Program for the Adobe Import/Export Form Data APIs?`}</h2>
    <p>{`The Import/Export PDF Form Data APIs programmatically import and export data from form fields at scale.`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <p>{`Primary capabilities of the Export PDF Form Data API include:`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <ul>
      <li parentName="ul">
        <p parentName="li">{`Export the form data as key/value pairs from a filled interactive PDF form (AcroForm/Static XFA).`}</p>
      </li>
      <li parentName="ul">
        <p parentName="li">{`Export the JSON structure from an empty interactive PDF form (AcroForm/Static XFA), to populate with values for use in the Import Form Data service.`}</p>
      </li>
    </ul>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <p>{`Primary capabilities of the Import PDF Form Data API include:`}</p>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <ul>
      <li parentName="ul">{`Import the form data from key/value pair into an empty interactive PDF form (AcroForm/Static XFA).`}</li>
    </ul>
    <TextBlock slots="text" width="100%" theme="lightest" alignment="yes" paddingTop="5" paddingBottom='5' className="py-0 div-p-0 left-content accessibility-text-blade" mdxType="TextBlock" />
    <p>{`Use this form to have an Adobe representative contact you with more information about the Beta program or to answer other questions you have about the APIs. For additional information, please refer to the `}<a parentName="p" {...{
        "href": "https://developer.adobe.com/document-services/docs/apis/#tag/Export-PDF-Form-Data"
      }}>{`documentation`}</a>{`.`}</p>

    </MDXLayout>;
}
;
MDXContent.isMDXComponent = true;
      